import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Grid, TextField, Card, CardContent, Typography, Button } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

function BankDetails({ formData, handleFormDataChange, handleSubmit }) {
    const [fileName, setFileName] = useState('');

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name);
            const base64 = await convertToBase64(file);
            handleFormDataChange('bank_details', {
                ...formData.bank_details,
                passbook_file: base64,
                passbook_path: 'documents/bank'
            });
        }
    };

    const handleBankChange = (field) => (event) => {
        handleFormDataChange('bank_details', {
            ...formData.bank_details,
            [field]: event.target.value
        });
    };

    return (
        <Card sx={{ margin: 2 }}>
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />
            <CardContent>
                <Typography color="#1976d2" gutterBottom sx={{ fontSize: '20px', marginBottom: '20px' }}>
                    <strong style={{ fontWeight: 600 }}>Bank Details</strong>
                </Typography>
                <Grid container spacing={5.5}>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            required
                            fullWidth
                            label="Bank Name"
                            value={formData.bank_details?.bank_name || ''}
                            onChange={handleBankChange('bank_name')}
                            InputLabelProps={{ shrink: true }}
                            size='small'
                            sx={{
                                width: "100%",
                                '& .MuiFormLabel-asterisk': {
                                    color: 'red',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            required
                            fullWidth
                            label="Account Number"
                            value={formData.bank_details?.account_num || ''}
                            onChange={handleBankChange('account_num')}
                            InputLabelProps={{ shrink: true }}
                            size='small'
                            sx={{
                                width: "100%",
                                '& .MuiFormLabel-asterisk': {
                                    color: 'red',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            required
                            fullWidth
                            label="Branch Name"
                            value={formData.bank_details?.branch_name || ''}
                            onChange={handleBankChange('branch_name')}
                            InputLabelProps={{ shrink: true }}
                            size='small'
                            sx={{
                                width: "100%",
                                '& .MuiFormLabel-asterisk': {
                                    color: 'red',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            required
                            fullWidth
                            label="IFSC Code"
                            value={formData.bank_details?.ifsc || ''}
                            onChange={handleBankChange('ifsc')}
                            InputLabelProps={{ shrink: true }}
                            size='small'
                            sx={{
                                width: "100%",
                                '& .MuiFormLabel-asterisk': {
                                    color: 'red',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <input
                            type="file"
                            accept=".pdf,.jpg,.jpeg,.png"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                            id="passbook-upload"
                        />
                        <label htmlFor="passbook-upload">
                            <Button
                                variant="outlined"
                                component="span"
                                startIcon={<CloudUploadIcon />}
                                size='medium'
                                sx={{
                                    width: "100%",
                                    padding: '7px 0px',
                                    textTransform: 'none',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    overflow: 'hidden',
                                }}
                            >
                                <span
                                    style={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        display: 'inline-block',
                                        maxWidth: '100%',
                                        textAlign: 'center',
                                    }}
                                    title={formData.bank_details?.passbook_copy|| fileName || `Upload Passbook`}
                                >
                                    {formData.bank_details.passbook_copy || fileName || 'Upload Passbook'}

                                </span>

                            </Button>
                        </label>
                        {formData.bank_details?.passbook_file && (
                            <Typography variant="caption" display="block" sx={{ mt: 1, color: 'green' }}>
                                File saved successfully
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} sx={{ height: "80px", display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                        <Button
                            variant="contained"
                            onClick={handleSubmit}
                            sx={{
                                backgroundColor: '#1976d2',
                                '&:hover': {
                                    backgroundColor: '#1976d2',
                                },
                            }}
                        >
                            Submit
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

export default BankDetails;